import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.calculationView.calculationStatusSection.title',
    defaultMessage: 'Status',
    description: 'Title of the status section',
  },
  properties: {
    isConcept: {
      id: 'properties.isConcept',
      defaultMessage: 'Concept',
      description: 'Title of the calculation is concept status in the status section',
    },
    isIncludingVat: {
      id: 'properties.isIncludingVat',
      defaultMessage: 'Including VAT',
      description: 'Title of the calculation is including vat status in the status section',
    },
    isPaid: {
      id: 'properties.isPaid',
      defaultMessage: 'Paid',
      description: 'Title of the calculation is paid status in the status section',
    },
    paidAt: {
      id: 'properties.paidAt',
      defaultMessage: 'Paid at',
      description: 'Title of the calculation paid at status in the status section',
    },
    createdAt: {
      id: 'properties.createdAt',
      defaultMessage: 'Created at',
      description: 'Title of the calculation created at status in the status section',
    },
    pricingAt: {
      id: 'properties.pricingAt',
      defaultMessage: 'Pricing at',
      description: 'Title of the calculation pricing at status in the status section',
    },
  },
};

export default defineMessages(translations);
